<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :permission="permissionList"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <table-column-set :THIS_TO_PARENT="this" slot="menuRight" />

      <template slot="workOrderId" slot-scope="{ row }">
        <el-button type="text" @click="handleView(row)" style="color: #409eff">
          {{ row.workOrderId }}
        </el-button>
      </template>

      <template slot="orderStatus" slot-scope="{ row }">
        <el-tag :type="getStatusType(row.orderStatus)" size="small" effect="light">
          {{ getStatusText(row.orderStatus) }}
        </el-tag>
      </template>

      <template slot="auditStatus" slot-scope="{ row }">
        <el-tag :type="getAuditStatusType(row.auditStatus)" size="small" effect="light">
          {{ getAuditStatusText(row.auditStatus) }}
        </el-tag>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-view" @click="handleView(row)" style="color: #409eff; margin-right: 8px">
          查看
        </el-button>
        <el-button v-if="isPendingAudit(row)" type="text" size="small" icon="el-icon-check" @click="handleReview(row, 'audit')" style="color: #67c23a; margin-right: 8px">
          审核
        </el-button>
        <el-button v-if="isPendingAudit(row)" type="text" size="small" icon="el-icon-close" @click="handleReview(row, 'reject')" style="color: #f56c6c">
          驳回
        </el-button>
      </template>
    </avue-crud>

    <el-dialog
      :title="reviewDialog.action === 'audit' ? '审核巡检工单' : '驳回巡检工单'"
      :visible.sync="reviewDialog.visible"
      width="480px"
      append-to-body
      @close="resetReviewDialog"
    >
      <el-form ref="reviewForm" :model="reviewDialog" :rules="reviewRules" label-width="90px">
        <el-form-item label="工单编号">
          <span>{{ reviewDialog.row ? reviewDialog.row.workOrderId : "--" }}</span>
        </el-form-item>
        <el-form-item label="原因" prop="auditReason">
          <el-input
            v-model="reviewDialog.auditReason"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入原因"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="reviewDialog.visible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="reviewDialog.loading" @click="submitReview">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { searchTimeConfig } from "@/basic-common/util/common";
import { auditInspectionTask, getList, rejectInspectionTask } from "./api";

export default {
  name: "dispatched-inspection-task-audit",
  mixins: [crudMixins],
  data () {
    return {
      apiConfig: { getList },
      defaultParams: {},
      reviewDialog: {
        visible: false,
        loading: false,
        action: "audit",
        row: null,
        auditReason: "",
      },
      reviewRules: {
        auditReason: [
          { required: true, message: "请输入原因", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!value || !value.trim()) {
                callback(new Error("请输入原因"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      option: {
        ...this.$store.state.publicOption,
        stripe: true,
        menu: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: false,
        menuWidth: 220,
        menuAlign: "center",
        searchBtn: true,
        searchResetBtn: true,
        searchMenuSpan: 6,
        column: [
          {
            label: "工单编号",
            prop: "workOrderId",
            align: "center",
            overHidden: true,
            slot: true,
            search: true,
            searchPlaceholder: "请输入工单编号",
            searchSpan: 6,
          },
          {
            label: "计划名称",
            prop: "extPlanName",
            align: "center",
            overHidden: true,
            search: true,
            searchPlaceholder: "请输入计划名称",
            searchSpan: 6,
          },
          {
            label: "巡检路线",
            prop: "inspectionRouteName",
            align: "center",
            overHidden: true,
            search: true,
            searchPlaceholder: "请输入巡检路线",
            searchSpan: 6,
          },
          {
            label: "班组",
            prop: "teamName",
            align: "center",
            overHidden: true,
          },
          {
            label: "计划时间",
            prop: "planTime",
            align: "center",
            overHidden: true,
            formatter: (row) => {
              return (row.cycleStartTime || "--") + "~" + (row.cycleEndTime || "--");
            },
          },
          {
            label: "实际结束时间",
            prop: "actualEndTime",
            align: "center",
            overHidden: true,
          },
          {
            label: "执行状态",
            prop: "orderStatus",
            align: "center",
            overHidden: true,
            slot: true,
          },
          {
            label: "审核状态",
            prop: "auditStatus",
            align: "center",
            overHidden: true,
            slot: true,
          },
          {
            ...searchTimeConfig,
            label: "创建时间",
            paramsKey: ["startTime", "endTime"],
            hide: true,
          },
        ],
      },
    };
  },
  methods: {
    getStatusType (status) {
      const typeMap = {
        2: "success",
        4: "danger",
      };
      return typeMap[Number(status)] || "info";
    },
    getStatusText (status) {
      const textMap = {
        2: "已完成",
        4: "超时完成",
      };
      return textMap[Number(status)] || "未知";
    },
    getAuditStatusText (status) {
      const textMap = {
        0: "未审核",
        1: "审核通过",
        2: "已驳回",
      };
      return textMap[status == null ? 0 : Number(status)] || "未审核";
    },
    getAuditStatusType (status) {
      const typeMap = {
        0: "info",
        1: "success",
        2: "danger",
      };
      return typeMap[status == null ? 0 : Number(status)] || "info";
    },
    isPendingAudit (row) {
      const status = row && row.auditStatus == null ? 0 : Number(row.auditStatus);
      return status === 0;
    },
    handleReview (row, action) {
      if (!this.isPendingAudit(row)) {
        this.$message.warning("该巡检工单已审核或已驳回，不能重复操作");
        return;
      }
      this.reviewDialog.visible = true;
      this.reviewDialog.action = action;
      this.reviewDialog.row = row;
      this.reviewDialog.auditReason = "";
      this.$nextTick(() => {
        if (this.$refs.reviewForm) {
          this.$refs.reviewForm.clearValidate();
        }
      });
    },
    resetReviewDialog () {
      this.reviewDialog.loading = false;
      this.reviewDialog.action = "audit";
      this.reviewDialog.row = null;
      this.reviewDialog.auditReason = "";
      if (this.$refs.reviewForm) {
        this.$refs.reviewForm.clearValidate();
      }
    },
    submitReview () {
      this.$refs.reviewForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        const row = this.reviewDialog.row;
        if (!row || !row.id) {
          this.$message.warning("请选择巡检工单");
          return;
        }
        const api = this.reviewDialog.action === "audit" ? auditInspectionTask : rejectInspectionTask;
        this.reviewDialog.loading = true;
        try {
          await api({
            id: row.id,
            auditReason: this.reviewDialog.auditReason.trim(),
          });
          this.$message.success(this.reviewDialog.action === "audit" ? "审核成功" : "驳回成功");
          this.reviewDialog.visible = false;
          this.onLoad(this.page);
        } catch (error) {
          console.error("巡检工单审核操作失败:", error);
        } finally {
          this.reviewDialog.loading = false;
        }
      });
    },
    handleView (row) {
      this.$router.push(`/dispatched-personnel-track/InspectionTaskManage/detail/${row.id}`);
    },
  },
};
</script>
